import moment from "moment";
import { getOrganizationExtraInfo } from "../shared/db/extra-info-db";
import { store } from "../stores/store";

export const isValidEmail = (str) => {
  return (!/(\.{2}|-{2}|_{2})/.test(str) && /^[a-zA-Z0-9][a-zA-Z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/.test(str));
};

export const isValidPhoneNumber = (str) => {
  return /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(str);
};


export const getViewBoxByPath = (pathStr: string): string => {
  // create the path element
  const svg = document.createElementNS("http://www.w3.org/2000/svg", 'svg');
  const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
  path.setAttribute('d', pathStr);
  svg.appendChild(path);

  // append to document
  document.body.appendChild(svg);

  // get the bounding box of the path
  const bbox = path.getBBox();

  // remove from document
  svg.remove();

  return `${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}`;
}

export const getExtraInfoKeyByName = async (name: string) => {
  const state = store.getState();
  let keys;

  if (Object.keys(state.auth.extraInfoKeys).length > 0) {
    keys = state.auth.extraInfoKeys;
  }
  else {
    keys = await getOrganizationExtraInfo();
  }

  return keys[name] || '';
}

export const getStartAndEndOfDate = () => {
  const startDate = moment().startOf('day');
  const endDate = moment().endOf('day');

  return [startDate, endDate];
}

export const getLast30DayDate = () => {
  const endDate = moment().endOf('day');
  const startDate = moment().subtract(30, 'days').startOf('day');

  return [startDate, endDate];
}

export const groupItemsIntoPages = <T>(items: T[], itemsPerPage: number): (T[])[] => {
  return Array.from({ length: Math.ceil(items.length / itemsPerPage) }, (v, i) =>
    items.slice(i * itemsPerPage, (i + 1) * itemsPerPage)
  );
}